"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMe = void 0;
const core_1 = require("@zodios/core");
const user_1 = require("../core/user");
exports.getMe = (0, core_1.makeEndpoint)({
    method: "get",
    path: "/app/me",
    alias: "getMe",
    parameters: [],
    response: user_1.userSchema,
});
//# sourceMappingURL=getMe.js.map